import Dexie from 'dexie'
import './me_common'
import { auth, getRedirectResult } from 'Src/firebase'

import { exitIntentDialog } from 'Src/me/pages/guest/proposals/new/exitIntentDialog'
import { renderLoading } from 'Src/me/pages/guest/proposals/new/loading'
import { chat } from 'Src/me/pages/guest/proposals/new/chat'
import { showLoading, hideLoading } from 'Src/me/pages/guest/proposals/new/utils'

window.addEventListener('DOMContentLoaded', async () => {
  // ローディング
  renderLoading()

  // 離脱防止ダイアログ
  const { beforeUnloadHandler } = exitIntentDialog()

  // LINE認証のリダイレクト結果確認
  let idToken = null
  try {
    // LINE認証からのリダイレクト結果を最初に確認
    const redirectResult = await getRedirectResult(auth)

    if (redirectResult && redirectResult.user) {
      idToken = await redirectResult.user.getIdToken()
    } else {
      // 通常のアクセス時（既にログイン済みかチェック）
      const user = await new Promise(resolve => {
        const unsubscribe = auth.onAuthStateChanged(user => {
          unsubscribe()
          resolve(user)
        })
      })

      if (user) {
        idToken = await user.getIdToken()
      }
    }
  } catch (error) {
    // エラーでも処理を続行（チャット画面を表示）
    console.error('認証確認エラー:', error)
  }

  if (idToken) {
    const dbExists = await Dexie.exists('NurikaeProposalsDatabase')
    if (dbExists) {
      try {
        // IndexedDBからデータ取得とCV処理
        const db = await new Dexie('NurikaeProposalsDatabase').open()
        const nurikaeProposalsData = await db.table('proposals').toArray()
        const proposalsData = nurikaeProposalsData.slice(-1)[0].data

        if (proposalsData) {
          const lineUserData = {
            id_token: idToken,
            provider_id: 'oidc.line'
          }
          const response = await fetch('/me/guest/proposals', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
            },
            body: JSON.stringify({
              ...lineUserData,
              ...proposalsData
            })
          })

          const result = await response.json()

          // 再訪問時を考慮してテーブルを削除
          db.delete()

          if (response.ok && result.status === 'success') {
            // リダイレクトのため離脱防止ダイアログを解除
            window.removeEventListener('beforeunload', beforeUnloadHandler)

            // 結果画面へリダイレクト
            window.location.href = '/me/member/proposals'
            return
          }
        }
      } catch (error) {
        console.error('CV処理エラー:', error)

        // ローディング非表示
        hideLoading()
      }
    }
  }

  // チャット処理
  await chat({ beforeUnloadHandler })
})
